import { eventBus } from '@/bus';
import { getController, postController } from '@/controllers/request';
import {
  ACTION,
  EVENTBUS_EVENTS,
  MODULE,
  PUBLICATOR_STATUS,
  SUBPANEL
} from '@/utils/constants';
import { randomNumber } from '@/utils/helpers';
import { errorMsg, mixin } from '@/utils/mixins';

export const errorTypes = error => {
  const types = {};

  function detectErrorType(code) {
    switch (code) {
      case 403:
        types.forbidden = true;
        break;
      case 404:
        types.notfound = true;
        break;
      case 401:
        types.forbidden = true;
        break;
      case 400:
        types.bad_request = true;
        break;
    }
  }

  if (Array.isArray(error)) {
    error.forEach(err => {
      detectErrorType(err.code);
    });
  } else {
    detectErrorType(error);
  }

  return types;
};

export const workSiteLabel = label => {
  return label == 'career_page'
    ? 'Карьерная страница'
    : label == 'hh'
    ? 'HH.ru'
    : label == 'avito'
    ? 'Avito'
    : label == 'superjob'
    ? 'SuperJob'
    : label == 'trudvsem'
    ? 'ТрудВсем'
    : label == 'rabotaru'
    ? 'Работа.Ру'
    : label;
};

export default {
  namespaced: true,
  state: {
    publishedVacancy: [],
    authForm: [],
    work_site_list: [
      'career_page',
      'hh',
      'avito',
      'superjob',
      // 'trudvsem',
      'rabotaru'
    ],
    selectedPublishedVacancy: null,
    hhData: {},
    importData: {},
    interval: null,
    billingTypes: [],
    nextEvent: null,
    command: '',
    vacancyItem: null,
    allTab: [],
    sendData: {},
    is_loading: false,
    publicatorLoading: false,
    trudvsemCity: ''
  },
  mixins: [mixin, errorMsg],
  mutations: {
    setFullWorkSiteList(state) {
      state.work_site_list = [
        'career_page',
        'hh',
        'avito',
        'superjob',
        // 'trudvsem',
        'rabotaru'
      ];
    },
    setImportData(state, payload) {
      state.importData = payload;
    },
    setAvailableOptions(state, payload) {
      if (payload.action === 'addOpt') {
        state.work_site_list.push(payload.name);
      } else {
        state.work_site_list = state.work_site_list.filter(
          item => item !== payload.name
        );
      }
    },
    setAuthorize(state, payload) {
      state.authForm = state.authForm.map(item => {
        if (typeof item == 'string') return item;
        if (item.name === payload.work_site) {
          return { ...item, authData: payload.auth };
        } else {
          return { ...item };
        }
      });
    },
    setAuthForm(state, payload) {
      if (state.authForm.some(f => f.name == payload.name)) return;

      const authData =
        payload.name == 'career_page' ? { work_site: payload.name } : {};

      state.authForm = [
        ...state.authForm,
        {
          id: randomNumber(),
          name: payload.name,
          options: state.work_site_list,
          authData
        }
      ];
    },
    setSendData(state, { workSite, form }) {
      for (let item in state.authForm) {
        if (
          state.authForm[item].authData.work_site &&
          workSite == state.authForm[item].name.toLowerCase()
        ) {
          state.sendData[state.authForm[item].name.toLowerCase()] = form;
        }
      }
      for (let item in state.sendData) {
        const auth = state.authForm.filter(el => item === el.name)[0];
        for (const [key] of Object.entries(auth.billingTypes || {})) {
          if (auth.activeBilling === key)
            state.sendData[item].billing_type_id = auth.activeBilling;
          state.sendData[item].billing_type = auth.billingTypes
            ? auth.billingTypes[auth.activeBilling]
            : '';
        }

        if (state.sendData[item].specializations) {
          state.sendData[item].specializations = Array.isArray(
            state.sendData[item].specializations
          )
            ? state.sendData[item].specializations.join(',')
            : state.sendData[item].specializations;
        }
        if (state.sendData[item].key_skills) {
          state.sendData[item].key_skills = Array.isArray(
            state.sendData[item].key_skills
          )
            ? state.sendData[item].key_skills.join(',')
            : state.sendData[item].key_skills;
        }

        if (state.sendData[item].working_time_modes) {
          state.sendData[item].working_time_modes = Array.isArray(
            state.sendData[item].working_time_modes
          )
            ? state.sendData[item].working_time_modes.join(',')
            : state.sendData[item].working_time_modes;
        }

        if (state.sendData[item].driver_license_types) {
          state.sendData[item].driver_license_types = Array.isArray(
            state.sendData[item].driver_license_types
          )
            ? state.sendData[item].driver_license_types.join(',')
            : state.sendData[item].driver_license_types;
        }
        if (state.sendData[item].can_response) {
          state.sendData[item].can_response = Array.isArray(
            state.sendData[item].can_response
          )
            ? state.sendData[item].can_response.join(',')
            : state.sendData[item].can_response;
        }
        if (state.sendData[item].areas) {
          state.sendData[item].areas = Array.isArray(state.sendData[item].areas)
            ? state.sendData[item].areas.join(',')
            : state.sendData[item].areas;
        }

        if (
          form['language_level'] &&
          state.sendData[item]?.language_level &&
          state.sendData[item]?.language_level.length
        ) {
          state.sendData[item].language_level = state.sendData[
            item
          ].language_level.map(item =>
            item.fields
              ? {
                  [item.fields[0].name]: item.fields[0].value,
                  [item.fields[1].name]: item.fields[1].value,
                  [item.fields[2].name]: item.fields[2].value,
                  [item.fields[3].name]: item.fields[3].value
                }
              : item
          );
        }

        if (
          form['another_work_place'] &&
          state.sendData[item]?.another_work_place &&
          state.sendData[item]?.another_work_place.length
        ) {
          state.sendData[item].another_work_place = state.sendData[
            item
          ].another_work_place.map(item =>
            item.fields
              ? {
                  [item.fields[0].name]: item.fields[0].value,
                  [item.fields[1].name]: item.fields[1].value,
                  [item.fields[2].name]: item.fields[2].value,
                  [item.fields[3].name]: item.fields[3].value,
                  [item.fields[4].name]: item.fields[4].value,
                  [item.fields[5].name]: item.fields[5].value
                }
              : item
          );
        }

        if (state.sendData[item].get_responds == 0) {
          state.sendData[item].get_responds_date = '';
          state.sendData[item].answer_responds = '';
          state.sendData[item].mass_vacancy = '';
        }
      }
    },
    setAuthTabs(state, payload) {
      state.authTabs &&
        state.authTabs.map((item, idx) => {
          if (item.name === payload.name) return;
          const result = {
            id: idx,
            label: payload.name,
            name: payload.name,
            loading: false,
            lazy: idx ? true : false
          };
          state.authTabs = [...state.authTabs, { ...result }];
        });
    },
    setDeleteAuthElement(state, payload) {
      state.authForm = state.authForm.filter(item => item.id !== payload.id);
    },
    setPlatformName(state, payload) {
      state.authForm = state.authForm.map(item => {
        if (item.id === payload.id) {
          // Добавляем по условию имя опции которую изменили
          state.work_site_list.map(el => {
            if (el === payload.name) {
              state.work_site_list = [
                ...state.work_site_list,
                payload.item.name
              ];
              // Удаляем опцию из списка на которую изменили
              state.work_site_list.splice(
                state.work_site_list.indexOf(payload.name),
                1
              );
            }
          });
          return { ...payload.item, name: payload.name };
        } else {
          return { ...item };
        }
      });
    },
    setNextEvent(state, nextEvent) {
      state.nextEvent = nextEvent;
    },
    setPublishedVacancy(state, publishedVacancy = []) {
      state.publishedVacancy = publishedVacancy;
    },
    setSelectedPublishedVacancy(state, vacancy) {
      state.selectedPublishedVacancy = vacancy;

      if (vacancy === null) {
        state.authForm = [];
      }
    },
    setSubpanelName(state, subpanel) {
      state.allTab.push(subpanel);
    },
    setDeauthenticate(state, payload) {
      state.authForm = state.authForm.map(item => {
        if (item.name === payload.work_site) {
          return { ...item, authData: {} };
        } else {
          return item;
        }
      });
    },
    setBillingTypes(state, payload) {
      state.authForm = state.authForm.map(item => {
        if (item.name === payload.work_site) {
          return {
            ...item,
            billingTypes: payload.billingTypes,
            activeBilling: Object.keys(payload?.billingTypes || {}).find(
              (t, i) => t == 'standard' || t == 'package' || i == 0
            )
          };
        } else {
          return item;
        }
      });
    },
    setBillingType(state, payload) {
      state.authForm = state.authForm.map(item => {
        if (item.name === payload.work_site) {
          return { ...item, activeBilling: payload.billingType };
        } else {
          return item;
        }
      });
    },
    setCommand(state, payload) {
      state.command = payload;
    },
    setVacancyItem(state, payload) {
      state.vacancyItem = payload;
    },
    setPublicatorLoading(state, val) {
      state.publicatorLoading = val;
    },
    setTrudvsemCity(state, val = '') {
      state.trudvsemCity = val;
    }
  },
  actions: {
    async getBillingTypes({ commit }, { work_site, search_string = '' }) {
      let billingTypes = {};

      try {
        const params = {
          offset: 0,
          search_string: search_string || '',
          limit: 100,
          module: 'HRPAC_PUBLISHED_VACANCY',
          to_pdf: true,
          action: 'get_rel_fields_values',
          field: 'billing_type',
          work_site
        };

        const { data } = await getController({ url: '', params });

        if (Array.isArray(data) && !data.length) {
          billingTypes = [];
        } else if (data && Object.keys(data).length) {
          billingTypes = { ...data };
        } else {
          billingTypes = null;
        }
        commit('setBillingTypes', { work_site, billingTypes });
      } catch (error) {
        console.error('Error', error);
      }
    },
    setSelectedPublishedVacancyAsync({ state }, vacancy) {
      state.selectedPublishedVacancy = vacancy;

      if (vacancy === null) {
        state.authForm = [];
      }
    },
    errorTypes(ctx, error) {
      const types = {};

      function detectErrorType(code) {
        switch (code) {
          case 403:
            types.unauthorized = true;
            break;
          case 404:
            types.notfound = true;
            break;
          case 400:
            types.bad_request = true;
            break;
        }
      }

      if (Array.isArray(error)) {
        error.forEach(err => {
          detectErrorType(err.code);
        });
      } else {
        detectErrorType(error);
      }

      return types;
    },
    confirmAuth({ state, dispatch, commit }) {
      const command = state.command;

      switch (command) {
        case 'toArchive':
          // if (state.hhData && !state.hhData.is_employer) {
          //   return dispatch(
          //     'common/catchError',
          //     {
          //       msg: 'Текущий пользователь не является работодателем'
          //     },
          //     { root: true }
          //   );
          // }
          // dispatch('archivePublishedVacancy', {
          //   external_id: state.vacancyItem.external_id.value
          // });
          break;
        case 'delete':
          // if (state.hhData && !state.hhData.is_employer) {
          //   return dispatch(
          //     'common/catchError',
          //     {
          //       msg: 'Текущий пользователь не является работодателем'
          //     },
          //     { root: true }
          //   );
          // }
          // commit(
          //   'common/setVisibleDialog',
          //   {
          //     name: 'publicator_delete_dialog',
          //     val: true
          //   },
          //   { root: true }
          // );
          // commit('setSelectedPublishedVacancy', state.vacancyItem);
          break;
        case 'publish':
          // dispatch('savePublishedVacancy', state.vacancyItem);
          break;
        case 'import':
          // if (state.hhData && !state.hhData.is_employer) {
          //   return dispatch(
          //     'common/catchError',
          //     {
          //       msg: 'Текущий пользователь не является работодателем'
          //     },
          //     { root: true }
          //   );
          // }
          commit(
            'common/setVisibleDialog',
            { name: 'publicator_import_dialog', val: true },
            { root: true }
          );
          break;
        case 'publishCopy':
          dispatch('copyPublishedVacancy', {
            external_id: state.vacancyItem.external_id.value
          });
          break;
        case 'refresh':
          // if (state.hhData && !state.hhData.is_employer) {
          //   return dispatch(
          //     'common/catchError',
          //     {
          //       msg: 'Текущий пользователь не является работодателем'
          //     },
          //     { root: true }
          //   );
          // }
          commit(
            'common/setVisibleDialog',
            { name: 'publicator_refresh_dialog', val: true },
            { root: true }
          );
          break;
        default:
          break;
      }
    },

    async checkLinkedVacancy({ rootState, dispatch }, url) {
      try {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action: 'checkIfExternalVacancyAlreadyLinked',
            external_id: url
          }
        });

        if (
          response?.data?.code == '200' &&
          response?.data?.status == '200' &&
          !response?.data?.result
        ) {
          dispatch('checkLink', url);
        } else if (
          response?.data?.code == '200' &&
          response?.data?.status == '200' &&
          response?.data?.result &&
          !response?.data?.error
        ) {
          if (
            response?.data?.result.header &&
            response?.data?.result.id &&
            response?.data?.result.name
          ) {
            rootState.common.visible_dialog.accept_import_dialog['data'] = {
              url: url,
              text: response?.data?.result.header.replace(
                '{link}',
                `<a href="${window.location.origin}/vacancies/${response?.data?.result.id}" style="color: #0088FF;  cursor: pointer;
                text-decoration: underline;" target="_blank">${response?.data?.result.name}</a>`
              )
            };
          }
          rootState.common.visible_dialog.accept_import_dialog[
            'display'
          ] = true;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async checkLink({ rootState, dispatch, commit, state }, url) {
      try {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            to_pdf: true,
            action: 'me',
            url,
            import: true
          }
        });

        const error = errorTypes(
          response?.data?.code ? response.data.code : ''
        ) || { forbidden: false };

        if (response && !response.error && !error.forbidden) {
          dispatch('searchPublishedVacancy', { external_id: url });
        } else if (response && error.forbidden) {
          commit('setImportData', {
            url,
            work_site: response.data.work_site || null
          });

          const availableElement = state.authForm.filter(
            item => item.name.toLowerCase() === response.data.work_site
          );

          if (!availableElement.length) {
            await commit('setAuthForm', {
              name: response.data.work_site || null,
              delete: response.data.work_site === 'hh' ? false : true
            });
          }

          rootState.common.visible_dialog.publicator_auth_dialog = true;
        }

        if (
          response?.data &&
          response?.data?.error &&
          response?.data?.error == 'token error'
        ) {
          commit('setImportData', {
            url,
            work_site: response.data.work_site || null
          });
          await commit('setAuthForm', {
            name: response.data.work_site || null,
            delete: response.data.work_site !== 'hh'
          });
          if (response.data?.work_site == 'trudvsem') {
            dispatch('deauthenticate', response.data.work_site);
          }
          rootState.common.visible_dialog.publicator_auth_dialog = true;
          if (response.data?.message) {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.message,
              duration: 15000,
              type: 'error'
            });
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response.data.error == 'token error') {
          commit('setImportData', {
            url,
            work_site: error.response.data.work_site || null
          });
          await commit('setAuthForm', {
            name: error.response.data.work_site || null,
            delete: error.response.data.work_site !== 'hh'
          });
          if (error.response.data?.work_site == 'trudvsem') {
            dispatch('deauthenticate', error.response.data.work_site);
          }
          rootState.common.visible_dialog.publicator_auth_dialog = true;
          if (error.response.data?.message) {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: error.response.data?.message,
              duration: 15000,
              type: 'error'
            });
          }
        }
      }
    },
    async checkAuth({ commit, state }, work_site = '') {
      try {
        const params = {
          module: MODULE.HRPAC_PUBLISHED_VACANCY,
          to_pdf: true,
          action: 'me',
          work_site
        };

        if (state.selectedPublishedVacancy?.edited && work_site == 'trudvsem') {
          params.publication_id = state.selectedPublishedVacancy.id.value;
        }
        commit('setPublicatorLoading', true);
        const response = await getController({ params });

        if (work_site && !response?.data && work_site == 'career_page') {
          const auth = {
            result: {
              work_site: 'career_page'
            },
            work_site: 'career_page'
          };
          commit('setAuthForm', {
            name: work_site,
            delete: work_site === 'hh' ? false : true
          });
          commit('setAuthorize', {
            work_site,
            auth: auth.result
          });
          commit('setAvailableOptions', { name: work_site });
        }

        if (
          response &&
          !!work_site &&
          !!response?.data &&
          !response?.data?.error
        ) {
          commit('setAuthForm', {
            name: work_site,
            delete: work_site === 'hh' ? false : true
          });
          commit('setAuthorize', {
            work_site,
            auth: response.data?.result
          });
          commit('setAvailableOptions', { name: work_site });
        } else if (
          !work_site &&
          response &&
          response?.data &&
          !response?.data?.error &&
          !state.authForm.length
        ) {
          if (Array.isArray(response.data)) {
            const hasCareerArchivedPublication = state.publishedVacancy.some(
              item =>
                item.work_site.value == 'career_page' &&
                item.status.value == 'archived'
            );
            const hasCareerActivePublication = state.publishedVacancy.some(
              item =>
                item.work_site.value == 'career_page' &&
                item.status.value == 'published'
            );
            if (hasCareerArchivedPublication && !hasCareerActivePublication) {
              const auth = {
                result: {
                  work_site: 'career_page'
                },
                work_site: 'career_page'
              };

              commit('setAuthForm', {
                name: auth.work_site,
                delete: true
              });
              commit('setAuthorize', {
                work_site: auth.work_site,
                auth: auth.result
              });
              commit('setAvailableOptions', { name: auth.work_site });
            } else
              state.authForm = state.authForm.filter(
                p => p.name !== 'career_page'
              );

            response.data.map(item => {
              if (!item && work_site == 'career_page') {
                item = {
                  result: {
                    work_site: 'career_page'
                  },
                  work_site: 'career_page'
                };
              }
              if (!item) return;
              if (!item.error && !!item.work_site) {
                commit('setAuthForm', {
                  name: item.work_site,
                  delete: item.work_site === 'hh' ? false : true
                });
                commit('setAuthorize', {
                  work_site: item.work_site,
                  auth: item.result
                });
                commit('setAvailableOptions', { name: item.work_site });
              }
            });
          }
        } else if (
          work_site &&
          response?.data?.error &&
          Array.isArray(response?.data?.result)
        ) {
          const workSite = {
            result: {},
            work_site:
              response.data.work_site || work_site != 'career_page'
                ? work_site
                : ''
          };

          if (!workSite.work_site) return;
          commit('setAuthForm', {
            name: workSite.work_site,
            delete: workSite.work_site === 'hh' ? false : true
          });
          commit('setAuthorize', {
            work_site: workSite.work_site,
            auth: workSite.result
          });
          commit('setAvailableOptions', { name: workSite.work_site });
        }
      } catch (error) {
        console.error(error);
        if (!error?.response?.data) return;

        if (
          error?.response?.data?.work_site &&
          Array.isArray(error?.response?.data?.result)
        ) {
          const workSite = {
            result: {},
            work_site:
              error.response.data.work_site || work_site != 'career_page'
                ? work_site
                : ''
          };

          if (!workSite.work_site) return;
          commit('setAuthForm', {
            name: workSite.work_site,
            delete: workSite.work_site === 'hh' ? false : true
          });
          commit('setAuthorize', {
            work_site: workSite.work_site,
            auth: workSite.result
          });
          commit('setAvailableOptions', { name: workSite.work_site });
        }
      } finally {
        commit('setPublicatorLoading', false);
      }
    },

    async authenticate({ commit, dispatch }, payload) {
      if (payload.work_site == 'trudvsem') {
        try {
          const params = {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action: 'login',
            to_pdf: true,
            work_site: payload.work_site,
            login: payload.auth_form.login || '',
            password: payload.auth_form.password || ''
          };

          const response = await getController({ params });

          if (response?.data) {
            commit('setAuthForm', {
              name: payload.work_site,
              delete: payload.work_site === 'hh' ? false : true
            });
            commit('setAuthorize', {
              work_site: payload.work_site,
              auth: response.data?.result
            });
            commit('setAvailableOptions', { name: payload.work_site });

            if (response.data?.ws_respond?.businessMessage) {
              setTimeout(
                () =>
                  errorMsg.methods.showNotification({
                    offset: 100,
                    showClose: true,
                    message: response.data.ws_respond.businessMessage,
                    duration: 15000,
                    type: 'error'
                  }),
                100
              );
            }
          }
        } catch (err) {
          console.error(err);
        }
      } else {
        window.open(
          `${process.env.VUE_APP_BASE_PATH}/index.php?module=HRPAC_PUBLISHED_VACANCY&action=get_code&to_pdf=true&work_site=${payload.work_site}`
        );

        dispatch('createAuthInterval', payload.work_site);
      }
    },
    createAuthInterval({ dispatch, state }, work_site) {
      state.interval = setInterval(checkAuth, 4000);

      async function checkAuth() {
        const authElement = (state.authForm || []).filter(
          item => item.name === work_site
        )[0];

        if (authElement?.authData && !authElement?.authData.work_site) {
          await dispatch('checkAuth', work_site);

          if (
            work_site == 'rabotaru' &&
            (!authElement.billingTypes ||
              !Object.values(authElement.billingTypes).length)
          ) {
            dispatch('getBillingTypes', { work_site });
          }
        } else {
          dispatch('destroyAuthInterval');
        }
      }
    },
    destroyAuthInterval({ state }) {
      clearInterval(state.interval);
    },
    async deauthenticate({ commit }, work_site) {
      try {
        const params = {
          module: MODULE.HRPAC_PUBLISHED_VACANCY,
          action: 'unauth',
          to_pdf: true,
          work_site
        };

        await getController({ params });

        commit('setDeauthenticate', { work_site });
      } catch (err) {
        console.error(err);
      }
    },
    async deletePublishedVacancy(
      { state, dispatch },
      { external_id, work_site, employer_id }
    ) {
      try {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action: ACTION.DELETE_PUBLISHED_VACANCY,
            subpanel: 'hrpac_vacancy_hrpac_published_vacancy',
            external_id,
            work_site,
            employer_id,
            id: state.selectedPublishedVacancy.id.value,
            jsqon_return: 1,
            to_pdf: true
          }
        });

        const error = dispatch('errorTypes', response.status);

        if (error.not_found || error.bad_request) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Ошибка удаления вакансии',
            type: 'error'
          });
        } else if (error.forbidden) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Для продолжения требуется авторизация на работном сайте',
            type: 'error'
          });
        } else if (response.data && response.data.error) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: errorMsg.methods.errorText(response.data.error).msg,
            duration: 25000,
            type: errorMsg.methods.errorText(response.data.error).type
          });
        } else {
          await dispatch(
            'searchAllPublishVacancy',
            state.vacancyItem?.vacancy_id?.value
          );
          eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, SUBPANEL.ID.PUBLICATOR);

          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Вакансия удалена',
            duration: 15000,
            type: 'info'
          });
        }
        // } else {
        //   errorMsg.methods.showNotification({
        //     offset: 100,
        //     showClose: true,
        //     duration: 25000,
        //     message: 'Для продолжения требуется авторизация на работном сайте',
        //     type: 'error'
        //   });
        // }
      } catch (err) {
        console.error(err);

        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          duration: 25000,
          message: 'Ошибка удаления вакансии',
          type: 'error'
        });
      }
    },
    async archivePublishedVacancy(
      { dispatch, state },
      { external_id, employer_id, work_site }
    ) {
      try {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action: ACTION.ARCHIVE_PUBLISHED_VACANCY,
            subpanel: 'hrpac_vacancy_hrpac_published_vacancy',
            external_id,
            employer_id,
            work_site,
            jsqon_return: 1,
            to_pdf: true
          }
        });
        const errors = dispatch('errorTypes', response.status);

        if (errors.notfound || errors.bad_request) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Ошибка архивирования вакансии',
            duration: 15000,
            type: 'error'
          });
        } else if (response.data && response.data.error) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: errorMsg.methods.errorText(response.data.error).msg,
            duration: 25000,
            type: errorMsg.methods.errorText(response.data.error).type
          });
        } else {
          await dispatch(
            'searchAllPublishVacancy',
            state.vacancyItem?.vacancy_id?.value
          );
          eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, SUBPANEL.ID.PUBLICATOR);

          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Вакансия архивирована',
            duration: 15000,
            type: 'info'
          });
        }
        // } else {
        //   errorMsg.methods.showNotification({
        //     offset: 100,
        //     showClose: true,
        //     duration: 25000,
        //     message: 'Для продолжения требуется авторизация на работном сайте',
        //     type: 'error'
        //   });
        // }
      } catch (err) {
        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка архивирования вакансии',
          duration: 15000,
          type: 'error'
        });

        console.error(err);
      }
    },
    async deactivatePublishedVacancy({ dispatch }, { external_id, work_site }) {
      try {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action: 'deleteCareerPagePublishedVacancy',
            subpanel: 'hrpac_vacancy_hrpac_published_vacancy',
            external_id,
            work_site,
            jsqon_return: 1,
            to_pdf: true
          }
        });

        const errors = await dispatch('errorTypes', response.status);

        if (errors.notfound || errors.bad_request) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Ошибка деактивирования вакансии',
            duration: 15000,
            type: 'error'
          });
        } else if (response.data && response.data.error) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: errorMsg.methods.errorText(response.data.error).msg,
            duration: 25000,
            type: errorMsg.methods.errorText(response.data.error).type
          });
        } else {
          eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, SUBPANEL.ID.PUBLICATOR);

          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Вакансия деактивирована',
            duration: 15000,
            type: 'info'
          });
        }
      } catch (err) {
        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка деактивации вакансии',
          duration: 15000,
          type: 'error'
        });

        console.error(err);
      }
    },
    async searchAllPublishVacancy({ commit, state }, id) {
      state.is_loading = true;
      try {
        const data = await getController({
          params: {
            module: MODULE.VACANCY_MODULE,
            action: ACTION.GET_SUBPANEL_JSON_DATA,
            subpanel: 'hrpac_vacancy_hrpac_published_vacancy',
            record: id,
            jsqon_return: 1,
            to_pdf: true
          }
        });
        commit('setPublishedVacancy', data?.data?.List);
        state.is_loading = false;
      } catch (err) {
        state.is_loading = false;
        console.error(err);
      }
    },
    async searchPublishedVacancy(
      { rootState, dispatch, state },
      { external_id }
    ) {
      try {
        // if (state.hhData && state.hhData.employer) {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action: ACTION.SEARCH_PUBLISHED_VACANCY,
            subpanel: 'hrpac_vacancy_hrpac_published_vacancy',
            record: rootState.vacancy.fields.id.value,
            external_id,
            vacancy_id: rootState.vacancy.fields.id.value,
            jsqon_return: 1,
            to_pdf: true
          }
        });

        const error = dispatch('errorTypes', response.status);

        if (error.not_found || error.bad_request) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Ошибка импорта вакансии',
            duration: 15000,
            type: 'error'
          });
        } else if (error.forbidden) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Текущий пользователь не является работодателем',
            type: 'error'
          });
        } else if (response.data && response.data.error) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: errorMsg.methods.errorText(response.data.error).msg,
            duration: 25000,
            type: errorMsg.methods.errorText(response.data.error).type
          });
        } else {
          await dispatch(
            'searchAllPublishVacancy',
            state.vacancyItem?.vacancy_id?.value
          );
          eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, SUBPANEL.ID.PUBLICATOR);

          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Вакансия успешно импортирована',
            duration: 15000,
            type: 'info'
          });
        }
        // } else {
        //   errorMsg.methods.showNotification({
        //     offset: 100,
        //     showClose: true,
        //     duration: 25000,
        //     message: 'Текущий пользователь не является работодателем',
        //     type: 'error'
        //   });
        // }
      } catch (err) {
        console.error(err);

        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка импорта вакансии',
          duration: 15000,
          type: 'error'
        });

        if (err?.response?.data?.error == 'token_error') {
          rootState.common.visible_dialog.publicator_auth_dialog = true;
        }
      }
    },
    async showPublishedVacancy(
      { dispatch, state },
      { external_id, visibility_vacancy }
    ) {
      try {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action: 'changeStatusVacancy',
            external_id,
            work_site: 'trudvsem',
            jsqon_return: 1,
            visibility_vacancy,
            to_pdf: true
          }
        });

        const error = dispatch('errorTypes', response.status);

        if (error.not_found || error.bad_request) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Ошибка скрытия/показа вакансии',
            duration: 15000,
            type: 'error'
          });
        } else if (error.forbidden) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Текущий пользователь не является работодателем',
            type: 'error'
          });
        } else if (response.data && response.data.error) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: errorMsg.methods.errorText(response.data.error).msg,
            duration: 25000,
            type: errorMsg.methods.errorText(response.data.error).type
          });
        } else {
          dispatch(
            'searchAllPublishVacancy',
            state.vacancyItem?.vacancy_id?.value
          );
          eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, SUBPANEL.ID.PUBLICATOR);

          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Статус вакансии изменен',
            duration: 15000,
            type: 'info'
          });
        }
      } catch (err) {
        console.error(err);

        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка скрытия/показа вакансии',
          duration: 15000,
          type: 'error'
        });
      }
    },
    async prolongateVacancy(
      { dispatch, state, rootState },
      { external_id, work_site }
    ) {
      try {
        // if (state.hhData && state.hhData.employer) {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action: ACTION.PROLONGATE_VACANCY,
            subpanel: 'hrpac_vacancy_hrpac_published_vacancy',
            external_id,
            work_site,
            jsqon_return: 1,
            to_pdf: true
          }
        });

        const errors = dispatch('errorTypes', response.status);

        if (errors.notfound) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Вакансия обновлена',
            duration: 15000,
            type: 'info'
          });
        } else if (errors.forbidden) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Вакансия не найдена',
            type: 'error'
          });
          rootState.common.visible_dialog.publicator_auth_dialog = true;
        } else if (response.data && response.data.error) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: errorMsg.methods.errorText(response.data.error).msg,
            duration: 25000,
            type: errorMsg.methods.errorText(response.data.error).type
          });
        } else {
          await dispatch(
            'searchAllPublishVacancy',
            state.vacancyItem?.vacancy_id?.value
          );
          eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, SUBPANEL.ID.PUBLICATOR);
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Вакансия обновлена',
            duration: 15000,
            type: 'info'
          });
        }
        // } else {
        //   errorMsg.methods.showNotification({
        //     offset: 100,
        //     showClose: true,
        //     duration: 25000,
        //     message: 'Текущий пользователь не является работодателем',
        //     type: 'error'
        //   });
        // }
      } catch (err) {
        console.error(err);

        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка продления вакансии',
          duration: 15000,
          type: 'error'
        });

        if (err?.response?.data?.error == 'token_error') {
          rootState.common.visible_dialog.publicator_auth_dialog = true;
        }
      }
    },
    async copyPublishedVacancy(
      { dispatch, state, rootState },
      { external_id, work_site }
    ) {
      try {
        const response = await getController({
          params: {
            module: MODULE.HRPAC_PUBLISHED_VACANCY,
            action:
              work_site == 'avito'
                ? ACTION.PROLONGATE_VACANCY
                : ACTION.COPY_PUBLISHED_VACANCY,
            subpanel: 'hrpac_vacancy_hrpac_published_vacancy',
            external_id,
            work_site,
            jsqon_return: 1,
            to_pdf: true
          }
        });

        const error = await dispatch('errorTypes', response.status);

        if (error.forbidden) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Текущий пользователь не является работодателем',
            type: 'error'
          });
        } else if (error.not_found || error.bad_request) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: 'Ошибка публикации вакансии',
            duration: 15000,
            type: 'error'
          });
        } else if (response.data && response.data.error) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: errorMsg.methods.errorText(response.data.error).msg,
            duration: 25000,
            type: errorMsg.methods.errorText(response.data.error).type
          });
          if (response.data?.ws_respond?.error?.error === 'unauthorized') {
            rootState.common.visible_dialog.publicator_auth_dialog = true;
          }
        } else {
          await dispatch(
            'searchAllPublishVacancy',
            state.vacancyItem?.vacancy_id?.value
          );
          setTimeout(() => {
            eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, SUBPANEL.ID.PUBLICATOR);

            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: 'Вакансия опубликована повторно',
              duration: 15000,
              type: 'info'
            });
          }, 200);
        }
        // } else {
        //   errorMsg.methods.showNotification({
        //     offset: 100,
        //     showClose: true,
        //     duration: 25000,
        //     message: 'Текущий пользователь не является работодателем',
        //     type: 'error'
        //   });
        // }
      } catch (err) {
        console.error(err);

        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка публикации вакансии',
          duration: 15000,
          type: 'error'
        });
      }
    },
    async savePublishedVacancy({ rootState, state, dispatch }, fields) {
      try {
        const formData = new FormData();
        formData.set('module', MODULE.HRPAC_PUBLISHED_VACANCY);
        formData.set('action', ACTION.SAVE_PUBLISHED_VACANCY);

        if (
          state.selectedPublishedVacancy?.status?.value !=
            PUBLICATOR_STATUS.DRAFT ||
          !fields.id
        ) {
          formData.set(
            'record',
            fields.duplicate ? '' : fields?.id?.value || ''
          );
        }

        formData.set('prefill[vacancy_id]', rootState.vacancy.fields.id.value);
        formData.set('jsqon_return', 1);
        formData.set('to_pdf', true);
        formData.set('work_sites', JSON.stringify(state.sendData));

        if (fields.duplicate) {
          formData.set('duplicate', true);
        }

        if (fields.only_publish == true) {
          formData.set(
            'work_site',
            typeof fields.work_site === 'string'
              ? fields.work_site
              : fields.work_site.value
          );
          formData.set('only_publish', true);
        } else {
          if (fields.only_publish == false) {
            formData.set('only_publish', false);
            formData.set('publish', false);
          } else {
            formData.set('publish', true);
          }
        }

        const response = await postController({ options: formData });
        let errors = {};

        const infoMsgEdit = (work_site, action) => {
          const form = state.sendData[work_site];
          // Публикация //
          if (
            action === 'publish' &&
            form &&
            !form.nextDate &&
            !+form.mass_vacancy &&
            form.get_responds_date
          ) {
            return `вакансия опубликована. Система загрузит отклики, оставленные с ${form.get_responds_date}`;
          }
          if (
            action === 'publish' &&
            form &&
            form.nextDate &&
            !+form.mass_vacancy &&
            form.get_responds_date
          ) {
            return `вакансия опубликована. Сбор откликов начнётся с ${form.get_responds_date}`;
          }
          if (
            action === 'publish' &&
            form &&
            !form.nextDate &&
            +form.mass_vacancy &&
            form.get_responds_date
          ) {
            return `вакансия опубликована. Система загрузит отклики, оставленные с ${form.get_responds_date} и переведёт кандидатов на этап "добавлен"`;
          }
          if (
            action === 'publish' &&
            form &&
            form.nextDate &&
            +form.mass_vacancy &&
            form.get_responds_date
          ) {
            return `вакансия опубликована. Сбор откликов начнётся с ${form.get_responds_date}. Система переведёт кандидатов на этап "добавлен"`;
          }
          if (
            action === 'publish' &&
            form &&
            !form.nextDate &&
            !+form.mass_vacancy &&
            !form.get_responds_date
          ) {
            return `Вакансия опубликована`;
          }
          if (action === 'publish' && !form) {
            return `Вакансия опубликована`;
          }
          // Редактирование //
          if (
            action === 'edit' &&
            form &&
            !form.nextDate &&
            !+form.mass_vacancy &&
            form.get_responds_date
          ) {
            return `вакансия отредактирована. Система загрузит отклики, оставленные с ${form.get_responds_date}`;
          }
          if (
            action === 'edit' &&
            form &&
            form.nextDate &&
            !+form.mass_vacancy &&
            form.get_responds_date
          ) {
            return `вакансия отредактирована. Сбор откликов начнётся с ${form.get_responds_date}`;
          }
          if (
            action === 'edit' &&
            form &&
            !form.nextDate &&
            +form.mass_vacancy &&
            form.get_responds_date
          ) {
            return `вакансия отредактирована. Система загрузит отклики, оставленные с ${form.get_responds_date} и переведёт кандидатов на этап "добавлен"`;
          }
          if (
            action === 'edit' &&
            form &&
            form.nextDate &&
            +form.mass_vacancy &&
            form.get_responds_date
          ) {
            return `вакансия отредактирована. Сбор откликов начнётся с ${form.get_responds_date}. Система переведёт кандидатов на этап "добавлен"`;
          }
          if (
            action === 'edit' &&
            form &&
            !form.nextDate &&
            !+form.mass_vacancy &&
            !form.get_responds_date
          ) {
            return `Вакансия сохранена`;
          }
        };

        if (response && response.data) {
          for (let i in response.data) {
            let nubbersOfErrors = response.data[i].length;
            for (let j = 0; j < nubbersOfErrors; j++) {
              errors[i] = response.data[i][j].error
                ? errorMsg.methods.errorText(response.data[i][j].error)
                : {
                    msg:
                      !state.selectedPublishedVacancy?.status?.value ||
                      state.selectedPublishedVacancy?.status?.value ==
                        PUBLICATOR_STATUS.DRAFT
                        ? 'Вакансия сохранена'
                        : fields.only_publish || fields.publish
                        ? infoMsgEdit(i, 'publish')
                        : infoMsgEdit(i, 'edit'),
                    type: 'info'
                  };
            }
          }
          state.publishedVacancy = [];
          state.authForm = [];
          state.sendData = {};
          state.vacancyItem = null;

          if (response.data?.ws_respond?.errors) {
            response.data?.ws_respond?.errors.forEach(err =>
              setTimeout(
                () =>
                  errorMsg.methods.showNotification({
                    offset: 100,
                    showClose: true,
                    message: err?.user_message,
                    duration: 15000,
                    type: 'error'
                  }),
                100
              )
            );
          }
        }

        if (errors) {
          for (let i in errors) {
            setTimeout(
              () =>
                errorMsg.methods.showNotification({
                  offset: 100,
                  showClose: true,
                  message: `${workSiteLabel(i)}: ${errors[i].msg}`,
                  duration: 15000,
                  type: errors[i].type
                }),
              100
            );
          }
        } else {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message:
              fields.only_publish || fields.publish
                ? 'Вакансия опубликована'
                : 'Вакансия сохранена',
            duration: 15000,
            type: 'info'
          });
        }

        state.sendData = {};
        rootState.common.requestSent = false;
      } catch (err) {
        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка публикации вакансии',
          duration: 15000,
          type: 'error'
        });
        state.sendData = {};
      }
      const timer = setTimeout(async () => {
        await dispatch(
          'searchAllPublishVacancy',
          state.vacancyItem?.vacancy_id?.value
        );
        eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, SUBPANEL.ID.PUBLICATOR);
        clearTimeout(timer);
      }, 1000);
    }
  }
};
